module.exports = __webpack_public_path__ + "media/images/icons/icons_small/16_lipstick-57190fe7433de41f11a683c8f12d7e9f.png";